export const site = {
  storeName: process.env.REACT_APP_STORENAME as string,
  legacyContext: process.env.REACT_APP_LEGACY_CONTEXT as string,
  transactionContext: process.env.REACT_APP_TRANSACTION_CONTEXT as string,
  searchContext: process.env.REACT_APP_SEARCH_CONTEXT as string,
  searchContextEfood: process.env.REACT_APP_SEARCH_CONTEXT_EFOOD as string,
  dxContext: process.env.REACT_APP_DX_CONTEXT as string,
  cmcPath: "/lobtools/cmc/ManagementCenterMain",
};
